import { MutableRefObject, useEffect } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'src/utils/bodyScrollLock';

export default function useBodyScrollLock(
  scrollableEleRef: MutableRefObject<HTMLElement | null>,
  lockBodyScroll = true
) {
  useEffect(() => {
    const currentTarget = scrollableEleRef.current;
    if (!currentTarget || !lockBodyScroll) return;
    disableBodyScroll(currentTarget, {
      allowTouchMove: (target) =>
        !lockBodyScroll || !!window.AzarJs || !!target.closest('.dragging'),
    });
    return () => {
      enableBodyScroll(currentTarget);
    };
  }, [lockBodyScroll, scrollableEleRef]);
}
